/**
 * @file Parent form adapter registry for modal form extension hooks.
 */

const BUILT_IN_PARENT_FORM_TYPES = new Set([
  "asset",
  "patient",
  "project",
  "task",
]);

const parentFormAdapters = new Map();

/**
 * Registers a parent form adapter for a non-built-in parent item type.
 * @param {string} type Parent item type.
 * @param {object} adapter Parent form adapter hooks.
 * @returns {void}
 */
export function registerParentFormAdapter(type, adapter) {
  if (!type || !adapter || typeof adapter !== "object") {return;}
  parentFormAdapters.set(String(type), {
    ...adapter,
    type: String(type),
  });
}

/**
 * Resolves a parent form adapter.
 * @param {string} type Parent item type.
 * @returns {object | null} Registered adapter.
 */
export function getParentFormAdapter(type) {
  if (!type) {return null;}
  return parentFormAdapters.get(String(type)) || null;
}

/**
 * Checks whether a type is supported by built-in forms or a registered adapter.
 * @param {string} type Parent item type.
 * @returns {boolean} Whether the form type is known.
 */
export function isKnownParentFormType(type) {
  if (!type) {return false;}
  return BUILT_IN_PARENT_FORM_TYPES.has(String(type)) ||
    parentFormAdapters.has(String(type));
}

/**
 * Returns built-in parent form types.
 * @returns {Array<string>} Built-in type names.
 */
export function getBuiltInParentFormTypes() {
  return Array.from(BUILT_IN_PARENT_FORM_TYPES);
}
